import { render, staticRenderFns } from "./TempoProgresso.vue?vue&type=template&id=5759eb89"
import script from "./TempoProgresso.vue?vue&type=script&lang=js"
export * from "./TempoProgresso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports